module.exports = __webpack_public_path__ + "img/B107.b2a55cab.jpg";